import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/core/auth/services/auth.service';
import { QRBasedPageType } from '@app/core/enums/questionnaire.enums';
import { Questionnaire, QuestionnaireSubmitPayload } from '@app/core/models/questionnaire.model';
import { CoreService } from '@app/core/services/core.service';
import { extractResponse } from '@app/shared/utils/response.utils';
import { CommonModule } from '@angular/common';
import { Spinner } from '@app/shared/components/spinner/spinner';
import { AlertMethod } from '@app/core/models/alert.model';
import { AlertService } from '@app/core/services/alert.service';
import { Split } from '../../components/preview/split/split';
import { Desktop } from '../../components/preview/desktop/desktop';
import { Mobile } from '../../components/preview/mobile/mobile';
import { finalize, Subscription } from 'rxjs';

@Component({
  selector: 'app-questionnaire-preview',
  imports: [CommonModule, Split, Desktop, Mobile],
  templateUrl: './questionnaire-preview.html',
  styleUrl: './questionnaire-preview.scss',
})
export class QuestionnairePreview implements OnInit {
  questionnaireId: string = '';
  orgId: string = '';
  questionnaire: Questionnaire | null = null;
  qrBasedPageType = QRBasedPageType;
  viewMode: 'split' | 'desktop' | 'mobile' = 'desktop';
  currentPage: number = 1;
  mobileScreenState: 'welcome' | 'questions' = 'welcome';
  isLoading: boolean = false;
  constructor(
    private coreService: CoreService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private alertService: AlertService
  ) {
    this.route.params.subscribe((params) => {
      this.questionnaireId = params['id'];
    });
    this.authService.userProfile$.subscribe((userProfile) => {
      if (userProfile) {
        this.orgId = userProfile.organizationId;
      }
    });
    this.coreService.questionnaireDeatils$.subscribe((questionnaire) => {
      if (questionnaire) {
        this.questionnaire = questionnaire;
      } 
    });
  }

  ngOnInit(): void {
   
    this.getQuestionnaireDetails();
  }


  setViewMode(mode: 'split' | 'desktop' | 'mobile') {
    this.viewMode = mode;
    // Reset mobile screen state when switching to mobile view
    if (mode === 'mobile' && this.hasQuestions) {
      this.mobileScreenState = 'questions';
    } else if (mode === 'split') {
      this.mobileScreenState = 'welcome';
    }
  }

  getQuestionnaireDetails() {

    this.coreService
      .getQuestionnaireDetails(this.orgId, this.questionnaireId) .subscribe();
  }

  refreshPreview() {
    // window.location.reload();
    this.getQuestionnaireDetails();
  }


  showQuestions() {
    this.mobileScreenState = 'questions';
  }

  showWelcome() {
    this.mobileScreenState = 'welcome';
  }

  get hasQuestions(): boolean {
    return !!(this.questionnaire?.questions && this.questionnaire.questions.length > 0);
  }

  refreshPage() {
    window.history.back();
  }


}
